
// 首页---->左导航栏
<template>
  <div class="" style="position: relative;background: #f7f7f7;">
    <el-container style="height: auto">
      <!-- 侧边栏 -->
      <div style="height:16px"></div>
      <el-aside class='public-nav show-aside' v-if="isCollapse">
        <!--  unique-opened :unique-opened="true" 如果要收起菜单，就给el-menu加这个参数  #ffd04b  active-text-color="#1167E9"-->
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-nav"
          @select="handleselect"
          @open="handleOpen"
          @close="handleClose"
          ref="menus"
          :router="true"
          text-color="#fff"
          :default-openeds="openeds"
        >
        <!-- :default-openeds="['1','2','3','4','5',]" -->
          <li class="home-page-style">
            <el-menu-item index="/dataStatisticsHomePage" class="el-submenu" v-if="hasPermissionGroup([...permissionGroup.homePage.homePageView])" style=";margin-bottom: 4px;">
              <div class="title navThemm">
                 <div class="icon-wrap">
                  <svg-icon icon-class="aside-home" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">首 页</span>
              </div>
            </el-menu-item>
          </li>
          <li role="menuitem" aria-haspopup="true" class="el-submenu" v-if="hasPermission(616)">
            <div class="el-submenu__title" style="padding-left: 20px; color: rgb(255, 255, 255);">
            <div class="title navThemm" @click="handleToSupplyChain">
              <div class="icon-wrap">
                <svg-icon icon-class="aside-gongying" style="font-size: 20px;"></svg-icon>
              </div>
              <span style="font-size: 16px;">供应协同</span>
            </div>
            </div>
          </li>

          <!-- <li class="home-page-style">
            <el-menu-item index="/dataStatisticsHomePage22" class="el-submenu" v-if="hasPermission(708)" style=";margin-bottom: 10px;">
              <div class="title navThemm">
                 <div class="icon-wrap">
                  <svg-icon icon-class="home-page" style="font-size: 30px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">首 页2</span>
              </div>
            </el-menu-item>
          </li> -->
          <el-submenu index="5" v-if="hasPermissionGroup([...permissionGroup.productionManagement.personnelManagement,...permissionGroup.productionManagement.taskManagement,...permissionGroup.productionManagement.productionTesting])">
            <template slot="title">
              <div class="title navThemm">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-shengchan" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">生产管理</span>
              </div>
            </template>
            <el-menu-item index="/productionManagement/personnelManagement" v-if="hasPermission(384)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-shengchan-renyuan" style="font-size:20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">生产人员管理</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/productionManagement/taskManagement/index" v-if="hasPermission(385)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-shengchan-renwu" style="font-size:20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">生产任务管理</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/productionManagement/deviceCheck/index" v-if="hasPermission(443)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-shengchan-jiance" style="font-size:20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">生产检测标准</span>
              </div>
            </el-menu-item>
          </el-submenu>

          <el-submenu index="1"   v-if="hasPermissionGroup([...permissionGroup.assetManager.assetView,...permissionGroup.assetManager.assetInsert,...permissionGroup.assetManager.assetReport,...permissionGroup.assetManager.assetReportIt,...permissionGroup.assetManager.assetDeletion])">
            <template slot="title">
              <div class="title navThemm">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-zichan" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">资产管理</span>
              </div>
            </template>
            <el-submenu index="1-1" v-if="hasPermissionGroup(permissionGroup.assetManager.assetView)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="aside-zichan-chengxian" style="font-size: 20px;"></svg-icon>
                  </div>
                  <span style="font-size: 12px;">资产呈现</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/index"
                v-if="hasPermission(182)"
                ><span class="menu-line">资产地图</span></el-menu-item
              >
              <el-menu-item
                class="firstmenus"
                index="/battery/index"
                v-if="hasPermission(2)"
                ><span class="menu-line">电池列表</span></el-menu-item
              >
              <el-menu-item
                class="firstmenus"
                index="/assets/chargeCabinet/index"
                v-if="hasPermission(115)"
                ><span class="menu-line">换电柜列表</span></el-menu-item
              >
              <el-menu-item
                class="firstmenus"
                index="/assets/vehicleList/index"
                v-if="hasPermission(456)"
                ><span class="menu-line">车辆列表</span></el-menu-item
              >
              <el-menu-item
                class="firstmenus"
                index="/assets/terminalManagement/index"
                v-if="hasPermission(282)"
                ><span class="menu-line">设备终端</span></el-menu-item
              >
                <el-menu-item
                class="firstmenus"
                index="/assets/sharingVehicleMap/index"
                v-if="hasPermission(575)"
                ><span class="menu-line">共享车辆地图</span></el-menu-item
              >
            </el-submenu>

            <el-submenu index="1-2"  v-if="hasPermissionGroup(permissionGroup.assetManager.assetInsert)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="aside-zichan-luru" style="font-size: 20px;"></svg-icon>
                  </div>
                  <span style="font-size: 12px;">资产录入</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/assets/inventory/batteryList/index"
                v-if="hasPermission(5)"
              ><span class="menu-line">电池</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/assets/inventory/chargeBox/index"
                v-if="hasPermission(117)"
              ><span class="menu-line">换电柜</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/assets/vehicleInOutManagement/index"
                v-if="hasPermission(459)"
              ><span class="menu-line">车辆出入库管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/assets/batterycategory/index"
                v-if="hasPermission(3)"
              ><span class="menu-line">电池品牌型号管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/assets/chargeCabinetList/index"
                v-if="hasPermission(116)"
              ><span class="menu-line">换电柜厂家型号管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/assets/vehicleBrandModel/index"
                v-if="hasPermission(460)"
              ><span class="menu-line">车辆品牌型号管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/assets/inventory/storeManagement/index"
                v-if="hasPermission(244)"
              ><span class="menu-line">仓库管理</span></el-menu-item>
<!--               <el-menu-item-->
<!--                index="/assets/FrameNumber/index"-->
<!--                style="padding-left:80px"-->
<!--                class="firstmenus"-->
<!--                v-if="hasPermission(293)"-->
<!--              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">车架号管理</span></el-menu-item>-->
            </el-submenu>

             <el-menu-item index="/assetsReportIt/index" v-if="hasPermissionGroup(permissionGroup.assetManager.assetReportIt)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-zichan-baoshi" style="font-size:20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">资产报失</span>
              </div>
            </el-menu-item>

            <el-menu-item index="/assetsReport/report" v-if="hasPermissionGroup(permissionGroup.assetManager.assetReport)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-zichan-chengxian" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">资产报表</span>
              </div>
            </el-menu-item>

              <el-menu-item index="/assets/assetDeletionRecord" v-if="hasPermissionGroup(permissionGroup.assetManager.assetDeletion)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-zichan-shanchu" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">资产删除记录</span>
              </div>
            </el-menu-item>
          </el-submenu>
          <!-- <div class="bgcolor" v-if="hasPermissionGroup([...permissionGroup.assetManager.assetView,...permissionGroup.assetManager.assetInsert,...permissionGroup.assetManager.assetReport])" changeOperatorView></div> -->
          <el-submenu index="2"   v-if="hasPermissionGroup([...permissionGroup.operateManager.operateOverview,...permissionGroup.operateManager.operateOrder,...permissionGroup.operateManager.operateBusiness,
          ...permissionGroup.operateManager.operatePrice,...permissionGroup.operateManager.operateCustomer,...permissionGroup.operateManager.operateFinance,...permissionGroup.operateManager.operateReport,...permissionGroup.operateManager.changeOperatorView,
          ...permissionGroup.operateManager.marketingActivities,...permissionGroup.operateManager.remoteUpgrade,...permissionGroup.operateManager.carOperatorView,...permissionGroup.operateManager.merchantManagement,...permissionGroup.operateManager.electrovalenceManagement,])">
              <template slot="title">
              <div class="title navThemm">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-yunying" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">运营管理</span>
              </div>
            </template>
            <el-menu-item index="/operationOverview" v-if="hasPermissionGroup(permissionGroup.operateManager.operateOverview)" class="secondary-menu secondary-menu-else">
               <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="aside-yunying-zulin" style="font-size: 20px" ></svg-icon>
                  </div>
                  <span style="font-size: 12px;">租赁运营概况</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/operation/changeOperatorView/index" v-if="hasPermissionGroup(permissionGroup.operateManager.changeOperatorView)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-yunying-huandian" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">换电运营概况</span>
              </div>
            </el-menu-item>
             <el-menu-item index="/operation/carOperatorView/index" v-if="hasPermissionGroup(permissionGroup.operateManager.carOperatorView)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-yunying-cheliang" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">车辆运营概况</span>
              </div>
            </el-menu-item>

            <el-menu-item index="/operation/bordereaux" v-if="hasPermissionGroup(permissionGroup.operateManager.bordereaux)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-yunying-huandianbaobiao" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">业务报表</span>
              </div>
            </el-menu-item>

            <el-submenu index="2-1" v-if="hasPermissionGroup(permissionGroup.operateManager.operateOrder)" class="secondary-menu">
              <template slot="title" >
                <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="aside-yunying-dingdan" style="font-size: 20px;"></svg-icon>
                 </div>
                 <span style="font-size: 12px;">订单管理</span>
                </div>
              </template>
              <el-menu-item
                index="/operation/order/exchange/index"
                class="firstmenus"
                style="padding-left:80px"
                v-if="hasPermission(75)"
              ><span class="menu-line">换电订单</span></el-menu-item>
              <el-menu-item
                index="/operation/order/exchangeHistory/index"
                class="firstmenus"
                style="padding-left:80px"
                v-if="hasPermission(76)"
              ><span class="menu-line">换电记录</span></el-menu-item>
              <el-menu-item
                index="/operation/order/lease/index"
                style="padding-left:80px"
                v-if="hasPermission(229)"
                class="firstmenus"
              ><span class="menu-line">电池租赁订单</span></el-menu-item>
              <el-menu-item
                index="/operation/order/batteryReplacementRecord/index"
                style="padding-left:80px"
                v-if="hasPermission(419)"
                class="firstmenus"
              ><span class="menu-line">电池更换记录</span></el-menu-item>
              <el-menu-item
                index="/operation/order/leaseExpired/index"
                style="padding-left:80px"
                v-if="hasPermission(230)"
                class="firstmenus"
              ><span class="menu-line">逾期订单</span></el-menu-item>
              <!-- display:none -->
              <el-menu-item
                index="/operation/order/salesOrder/index"
                style="padding-left:80px;"
                v-if="hasPermission(371)"
                class="firstmenus"
              ><span class="menu-line">销售订单</span></el-menu-item>
              <el-menu-item
                index="/operation/order/carsLeaseOrder/index"
                style="padding-left:80px"
                v-if="hasPermission(480)"
                class="firstmenus"
              ><span class="menu-line">车辆租赁订单</span></el-menu-item>
<!--              <el-menu-item-->
<!--                index="/operation/businessAccount/index"-->
<!--                style="padding-left:80px"-->
<!--                class="firstmenus"-->
<!--                v-if="hasPermission(311)"-->
<!--              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">资产使用情况</span></el-menu-item>-->
            </el-submenu>
            <el-submenu index="2-2" v-if="hasPermissionGroup(permissionGroup.operateManager.operateBusiness)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="aside-yunying-yewu" style="font-size: 20px;"></svg-icon>
                 </div>
                 <span style="font-size: 12px;">业务管理</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/operation/operationList/index"
                style="padding-left:80px"
                v-if="hasPermission(11)"
              ><span class="menu-line">运营商管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/proxy/index"
                style="padding-left:80px"
                v-if="hasPermission(596)"
              ><span class="menu-line">代理商管理</span></el-menu-item>

              <el-menu-item
                class="firstmenus"
                index="/operation/operationSite"
                style="padding-left:80px"
                v-if="hasPermission(10)"
              ><span class="menu-line">站点管理</span></el-menu-item>
               <el-menu-item
                class="firstmenus"
                index="/operation/LeasePointGroup/index"
                style="padding-left:80px"
                v-if="hasPermission(196)"
              ><span class="menu-line">站点分组</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/brandFranchisee/index"
                style="padding-left:80px"
                v-if="hasPermission(262)"
              ><span class="menu-line">品牌加盟商管理</span></el-menu-item>
              <el-menu-item
                index="/operation/allocation/index"
                style="padding-left:80px"
                class="firstmenus"
                v-if="hasPermission(14)"
              ><span class="menu-line">调拨管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/pushHistory/index"
                style="padding-left:80px"
                v-if="hasPermission(242)"
              ><span class="menu-line">消息推送记录</span></el-menu-item>
<!--              <el-menu-item-->
<!--                class="firstmenus"-->
<!--                index="/operation/operatorAudit/index"-->
<!--                style="padding-left:80px"-->
<!--                v-if="hasPermission(411)"-->
<!--              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">运营商审核</span></el-menu-item>-->
              <el-menu-item
                class="firstmenus"
                index="/operation/salesmanManagement/index"
                style="padding-left:80px"
                v-if="hasPermission(493)"
              ><span class="menu-line">业务员管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/siteProfitSharing/index"
                style="padding-left:80px"
                v-if="hasPermission(528)"
              ><span class="menu-line">分账配置</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/config/index"
                style="padding-left:80px"
                v-if="hasPermission(611)"
              ><span class="menu-line">运营商个性配置</span></el-menu-item>
            </el-submenu>
            <el-submenu index="2-3" v-if="hasPermissionGroup(permissionGroup.operateManager.operatePrice)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="aside-yunying-dingjia" style="font-size: 20px;"></svg-icon>
                 </div>
                 <span style="font-size: 12px;">定价管理</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/operation/LeaseTemplate/billingPage"
                style="padding-left:80px"
                v-if="hasPermission(12)"
              ><span class="menu-line">租赁计费模板</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/ChangeBatTemplate/billingPage"
                style="padding-left:80px"
                v-if="hasPermission(428)"
              ><span class="menu-line">换电计费模板</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/pricingManagement/SalesBillingTemplate/index"
                style="padding-left:80px"
                v-if="hasPermission(364)"
              ><span class="menu-line">销售计费模板</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/pricingManagement/carBillingTemplate/index"
                style="padding-left:80px"
                v-if="hasPermission(473)"
              ><span class="menu-line">车辆计费模板</span></el-menu-item>
            </el-submenu>
            <el-submenu index="2-4" v-if="hasPermissionGroup(permissionGroup.operateManager.operateCustomer)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="aside-yunying-kehu" style="font-size: 20px;"></svg-icon>
                  </div>
                  <span style="font-size: 12px;">客户管理</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/Customer/memberCustomers/index"
                style="padding-left:80px"
                v-if="hasPermission(73)"
              ><span class="menu-line">会员客户</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/Customer/pupuMember/index"
                style="padding-left:80px"
                v-if="hasPermission(617)"
              ><span class="menu-line">朴朴会员</span></el-menu-item>
<!--              <el-menu-item-->
<!--                class="firstmenus"-->
<!--                index="/Customer/idleMember/index"-->
<!--                style="padding-left:80px"-->
<!--                v-if="hasPermission(306)"-->
<!--              ><i class="Tertiary-icon"></i><i style="width:6px;display: inline-block;"></i><span class="menu-line">闲置会员客户</span></el-menu-item>-->
              <el-menu-item
                class="firstmenus"
                index="/Customer/disabledApply/index"
                style="padding-left:80px"
                v-if="hasPermission(236)"
              ><span class="menu-line">会员禁用审核</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/ClientManagement/clientPage"
                style="padding-left:80px"
                v-if="hasPermission(74)"
              ><span class="menu-line">注册客户</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/operation/realNameCheck/index"
                style="padding-left:80px"
                v-if="hasPermission(249)"
              ><span class="menu-line">实名认证记录</span></el-menu-item>
              <!-- /Customer/enterpriseUsers/index -->
              <el-menu-item
                class="firstmenus"
                index="/Customer/enterpriseUsers/index"
                style="padding-left:80px"
                v-if="hasPermission(636)"
              ><span class="menu-line">企业客户</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/Customer/blacklistList/index"
                style="padding-left:80px"
                v-if="hasPermission(631)"
              ><span class="menu-line">黑名单</span></el-menu-item>
            </el-submenu>
            <el-submenu index="2-5" v-if="hasPermissionGroup(permissionGroup.operateManager.operateFinance)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                    <div class="icon-wrap">
                        <svg-icon icon-class="aside-yunying-caiwu" style="font-size: 20px;"></svg-icon>
                    </div>
                    <span style="font-size: 12px;">财务管理</span>
                </div>
              </template>
              <el-menu-item
                index="/Finance/Recharge"
                style="padding-left:80px"
                v-if="hasPermission(19)"
                class="firstmenus"
              ><span class="menu-line">资金流水</span></el-menu-item>
              <!-- <el-menu-item
                index="/Finance/revenueManagement"
                style="padding-left:80px"
                v-if="hasPermission(276)"
                class="firstmenus"
              >订单收入记录</el-menu-item> -->
              <el-menu-item
                index="/Finance/leaseOrdersRevenue"
                style="padding-left:80px"
                v-if="hasPermission(398)"
                class="firstmenus"
              ><span class="menu-line">租赁订单收入记录</span></el-menu-item>
              <el-menu-item
                index="/Finance/revenueManagement2"
                style="padding-left:80px"
                v-if="hasPermission(424)"
                class="firstmenus"
              ><span class="menu-line">换电订单收入记录</span></el-menu-item>
              <el-menu-item
                index="/Finance/carsOrderRevenue"
                style="padding-left:80px"
                v-if="hasPermission(488)"
                class="firstmenus"
              ><span class="menu-line">车辆订单收入记录</span></el-menu-item>
              <el-menu-item
                index="/Finance/withdrawal"
                style="padding-left:80px;"
                v-if="hasPermission(101)"
                class="firstmenus"
              ><span class="menu-line">提现审核</span></el-menu-item>              
              <el-menu-item
                index="/Finance/thawApply"
                style="padding-left:80px;"
                v-if="hasPermission(502)"
                class="firstmenus"
              ><span class="menu-line">押金解冻审核</span></el-menu-item>
              <el-menu-item
                index="/Finance/abnormalRentRefund"
                style="padding-left:80px;"
                v-if="hasPermission(377)"
                class="firstmenus"
              ><span class="menu-line">异常退租审核</span></el-menu-item>
              <el-menu-item
                index="/Finance/memberBill/index"
                style="padding-left:80px"
                v-if="hasPermission(255)"
                class="firstmenus"
              ><span class="menu-line">会员账单</span></el-menu-item>
              <el-menu-item
                index="/Finance/rechargeRecord/index"
                style="padding-left:80px"
                v-if="hasPermission(534)"
                class="firstmenus"
              ><span class="menu-line">后台充值记录</span></el-menu-item>
              <el-menu-item
                index="/Finance/enterpriseRenewalApproval"
                style="padding-left:80px"
                v-if="hasPermission(656)"
                class="firstmenus"
              ><span class="menu-line">企业客户订单审核</span></el-menu-item>
              <el-menu-item
                index="/Finance/assetDepreciationRules"
                style="padding-left:80px;"
                v-if="hasPermission(654)"
                class="firstmenus"
              ><span class="menu-line">资产折旧规则</span></el-menu-item>
              <el-menu-item
                index="/Finance/assetDepreciationList"
                style="padding-left:80px;"
                v-if="hasPermission(655)"
                class="firstmenus"
              ><span class="menu-line">资产折旧明细</span></el-menu-item>
              <el-menu-item
                index="/Finance/deductionRecord"
                style="padding-left:80px;"
                v-if="hasPermission(701)"
                class="firstmenus"
              ><span class="menu-line">免押扣款记录</span></el-menu-item>
            </el-submenu>
            <el-submenu index="2-9" v-if="hasPermissionGroup(permissionGroup.operateManager.merchantManagement)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="aside-yunying-shangjia" style="font-size: 20px;"></svg-icon>
                 </div>
                 <span style="font-size: 12px;">换电商家管理</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/exchangeMerchantManagement/merchantManagement"
                style="padding-left:80px"
                v-if="hasPermission(678)"
              ><span class="menu-line">商家管理</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/exchangeMerchantManagement/siteRentReview"
                style="padding-left:80px"
                v-if="hasPermission(679)"
              ><span class="menu-line">场租审核</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/exchangeMerchantManagement/electricityChargeReview"
                style="padding-left:80px"
                v-if="hasPermission(680)"
              ><span class="menu-line">电费审核</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/exchangeMerchantManagement/withdrawalList"
                style="padding-left:80px"
                v-if="hasPermission(695)"
              ><span class="menu-line">提现记录</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/exchangeMerchantManagement/extensionList"
                style="padding-left:80px"
                v-if="hasPermission(733)"
              ><span class="menu-line">推广记录</span></el-menu-item>
            </el-submenu>
            <el-submenu index="2-6" v-if="hasPermissionGroup(permissionGroup.operateManager.marketingActivities)" class="secondary-menu">
              <!--   style="display:none"-->
              <template slot="title">
                <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="aside-yunying-yingxiao" style="font-size: 20px;"></svg-icon>
                 </div>
                 <span style="font-size: 12px;">营销活动</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/marketingActivities/coupon/index"
                style="padding-left:80px"
                v-if="hasPermission(336)"
              ><span class="menu-line">优惠券</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/marketingActivities/couponRecord/index"
                style="padding-left:80px"
                v-if="hasPermission(512)"
              ><span class="menu-line">优惠券发放记录</span></el-menu-item>
               <el-menu-item
                class="firstmenus"
                index="/marketingActivities/frozenCoupon/index"
                style="padding-left:80px"
                v-if="hasPermission(561)"
              ><span class="menu-line">冻结券</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/marketingActivities/userLabel/index"
                style="padding-left:80px"
                v-if="hasPermission(567)"
              ><span class="menu-line">用户标签</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/marketingActivities/userLevel/index"
                style="padding-left:80px"
                v-if="hasPermission(728)"
              ><span class="menu-line">用户等级</span></el-menu-item>
            </el-submenu>
           <el-submenu index="2-7" v-if="hasPermissionGroup(permissionGroup.operateManager.remoteUpgrade)" class="secondary-menu">
             <template slot="title">
                <div class="title">
                <div class="icon-wrap">
                   <svg-icon icon-class="aside-yunying-shengji" style="font-size: 20px;"></svg-icon>
                 </div>
                  <span style="font-size: 12px;">远程升级</span>
                </div>
              </template>
              <!-- <el-menu-item
                class="firstmenus"
                index="/operation/remoteUpgrade/communicationModule/index"
                style="padding-left:80px"
                v-if="hasPermission(342)"
              ><span class="menu-line">通讯模块</span></el-menu-item> -->
              <el-menu-item
                class="firstmenus"
               index="/operation/remoteUpgrade/bmsUpgrade/index"
                style="padding-left:80px"
                v-if="hasPermission(622)"
              ><span class="menu-line">BMS</span></el-menu-item>
              <!-- <el-menu-item
               class="firstmenus"
               index="/operation/remoteUpgrade/batterCommandBatch/index"
                style="padding-left:80px"
                v-if="hasPermission(584)"
              ><span class="menu-line">电池命令批量执行</span></el-menu-item> -->
            </el-submenu>
            <el-submenu index="2-8" v-if="hasPermissionGroup(permissionGroup.operateManager.apiInterface)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                 <div class="icon-wrap">
                   <svg-icon icon-class="aside-yunying-api" style="font-size: 20px;"></svg-icon>
                 </div>
                 <span style="font-size: 12px;">API接口服务</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/operation/apiInterface/accountAuthority/index"
                style="padding-left:80px"
                v-if="hasPermission(448)"
              ><span class="menu-line">账号权限管理</span></el-menu-item>
            </el-submenu>

            <el-menu-item index="/dashboard/operationReport" v-if="hasPermissionGroup(permissionGroup.operateManager.operateReport)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-yunying-huandianbaobiao" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">换电运营报表</span>
              </div>
            </el-menu-item>

            <el-menu-item index="/operation/serviceChargeBill" v-if="hasPermissionGroup(permissionGroup.operateManager.serviceChargebill)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-yunying-fuwufei" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">服务费账单</span>
              </div>
            </el-menu-item>
             <el-menu-item index="/operation/onlineBulletin" v-if="hasPermissionGroup(permissionGroup.operateManager.omlineBulletion)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-yunying-gonggao" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">线上公告</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/operation/shortMessageNumber" v-if="hasPermissionGroup(permissionGroup.operateManager.shortMessageNumber)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-yunying-duanxin" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">短信发送量统计</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/operation/electrovalenceManagement" v-if="hasPermissionGroup(permissionGroup.operateManager.electrovalenceManagement)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-yunying-dianjia" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">电价管理</span>
              </div>
            </el-menu-item>

           </el-submenu>
           <!-- <div class="bgcolor" v-if="hasPermissionGroup([...permissionGroup.operateManager.operateOverview,...permissionGroup.operateManager.operateOrder,...permissionGroup.operateManager.operateBusiness,...permissionGroup.operateManager.operatePrice,...permissionGroup.operateManager.operateCustomer,...permissionGroup.operateManager.operateFinance,...permissionGroup.operateManager.operateReport])"></div> -->
          <el-submenu index="3"  v-if="hasPermissionGroup([...permissionGroup.aftersaleManager.onlineMonitoring,...permissionGroup.aftersaleManager.offlineAftersale,...permissionGroup.aftersaleManager.personManager,...permissionGroup.aftersaleManager.aftersaleReport])">
               <template slot="title">
              <div class="title navThemm">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-shouhou" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">售后服务</span>
              </div>
            </template>
            <el-submenu index="3-1" v-if="hasPermissionGroup(permissionGroup.aftersaleManager.onlineMonitoring)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="aside-shouhou-xianshang" style="font-size: 20px;"></svg-icon>
                  </div>
                  <span style="font-size: 12px;">线上监控</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/monitoring/unusual"
                style="padding-left:80px"
                v-if="hasPermission(16)"
              ><span class="menu-line">电池异常告警(V1.0)</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/monitoring/towerAlarm"
                style="padding-left:80px"
                v-if="hasPermission(172)"
              ><span class="menu-line">电池异常告警(V2.0)</span></el-menu-item>
               <el-menu-item
                class="firstmenus"
                index="/monitoring/batteryAbnormalAlarm"
                style="padding-left:80px"
                v-if="hasPermission(515)"
              ><span class="menu-line">电池异常告警(V3.0)</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/monitoring/uDanDeviceController"
                style="padding-left:80px"
                v-if="hasPermission(672)"
              ><span class="menu-line">电池异常告警</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/monitoring/cabinetAlarm"
                style="padding-left:80px"
                v-if="hasPermission(440)"
              ><span class="menu-line">换电柜异常告警</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/monitoring/alarmRemind"
                style="padding-left:80px"
                v-if="hasPermission(224)"
              ><span class="menu-line">告警弹窗设置</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/monitoring/mpMonitorSet"
                style="padding-left:80px"
                v-if="hasPermission(704)"
              ><span class="menu-line">公众号告警设置</span></el-menu-item>
<!--              <el-menu-item-->
<!--                index="/monitoring/electronicFence"-->
<!--                style="padding-left:80px"-->
<!--                class="firstmenus"-->
<!--                v-if="hasPermission(17)"-->
<!--              ><span class="menu-line">电子围栏</span></el-menu-item>-->
            </el-submenu>
            <el-submenu index="3-2" v-if="hasPermissionGroup(permissionGroup.aftersaleManager.offlineAftersale)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="aside-shouhou-xianxia" style="font-size:20px;"></svg-icon>
                  </div>
                  <span style="font-size: 12px;">线下售后</span>
                </div>
              </template>
              <el-menu-item
                index="/afterSale/afterSaleJobs"
                style="padding-left:80px"
                v-if="hasPermission(205)"
                class="firstmenus"
              ><span class="menu-line">换电工单</span></el-menu-item>
              <el-menu-item
                index="/afterSale/faultContent"
                style="padding-left:80px"
                v-if="hasPermission(207)"
                class="firstmenus"
              ><span class="menu-line">换电故障定义</span></el-menu-item>
              <el-menu-item
                index="/operation/disableLogging/index"
                style="padding-left:80px"
                class="firstmenus"
                v-if="hasPermission(299)"
              ><span class="menu-line">仓门禁用记录</span></el-menu-item>
              <el-menu-item
                index="/operation/doorOpenRecord/index"
                style="padding-left:80px"
                class="firstmenus"
                v-if="hasPermission(718)"
              ><span class="menu-line">仓门开仓记录</span></el-menu-item>
              <el-menu-item
                index="/operation/doorDisablingReason/index"
                style="padding-left:80px"
                class="firstmenus"
                v-if="hasPermission(713)"
              ><span class="menu-line">仓门禁用原因</span></el-menu-item>
              <el-menu-item
                index="/afterSale/faultRecord"
                style="padding-left:80px"
                v-if="hasPermission(321)"
                class="firstmenus"
              ><span class="menu-line">租赁工单</span></el-menu-item>
              <el-menu-item
                index="/afterSale/bmstTreshold"
                style="padding-left:80px"
                v-if="hasPermission(453)"
                class="firstmenus"
              ><span class="menu-line">BMS保护阈值</span></el-menu-item>
              <el-menu-item
                index="/afterSale/hNdisabilitiesRecord"
                style="padding-left:80px"
                v-if="hasPermission(549)"
                class="firstmenus"
              ><span class="menu-line">华诺报障记录</span></el-menu-item>
              <el-menu-item
                index="/afterSale/workOrder"
                style="padding-left:80px"
                v-if="hasPermission(576)"
                class="firstmenus"
              ><span class="menu-line">BMS工单</span></el-menu-item>
            </el-submenu>
            <el-submenu index="3-3" v-if="hasPermissionGroup(permissionGroup.aftersaleManager.personManager)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="aside-shouhou-renyuan" style="font-size: 20px;"></svg-icon>
                  </div>
                  <span style="font-size: 12px;">人员管理</span>
                </div>
              </template>
              <el-menu-item
                index="/afterSale/afterSalePeople"
                style="padding-left:80px;"
                v-if="hasPermission(206)"
                class="firstmenus"
              ><span class="menu-line">售后人员</span></el-menu-item>
<!--              <el-menu-item-->
<!--                index="/afterSale/clockRecord"-->
<!--                style="padding-left:80px;"-->
<!--                v-if="hasPermission(208)"-->
<!--                class="firstmenus"-->
<!--              ><span class="menu-line">售后打卡记录</span></el-menu-item>-->
              <el-menu-item
                index="/afterSale/afterSaleRole"
                style="padding-left:80px;"
                v-if="hasPermission(554)"
                class="firstmenus"
              ><span class="menu-line">售后人员角色</span></el-menu-item>
            </el-submenu>
            <el-submenu index="3-4" v-if="hasPermissionGroup(permissionGroup.aftersaleManager.aftersaleReport)" class="secondary-menu">
              <template slot="title">
                <div class="title">
                  <div class="icon-wrap">
                    <svg-icon icon-class="aside-shouhou-baobiao" style="font-size: 20px;"></svg-icon>
                  </div>
                  <span style="font-size: 12px;">售后报表</span>
                </div>
              </template>
              <el-menu-item
                class="firstmenus"
                index="/dashboard/monitoring"
                style="padding-left:80px;display:none"
                v-if="hasPermission(24)"
              ><span class="menu-line">故障统计报表</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/dashboard/monitoring"
                style="padding-left:80px;display:none"
                v-if="hasPermission(24)"
              ><span class="menu-line">工单统计报表</span></el-menu-item>
              <el-menu-item
                class="firstmenus"
                index="/afterTheReport/report"
                style="padding-left:80px"
                v-if="hasPermission(24)"
              ><span class="menu-line">监控统计报表</span></el-menu-item>
            </el-submenu>
           </el-submenu>
           <!-- <div class="bgcolor" v-if="hasPermissionGroup([...permissionGroup.aftersaleManager.onlineMonitoring,...permissionGroup.aftersaleManager.offlineAftersale,...permissionGroup.aftersaleManager.personManager,...permissionGroup.aftersaleManager.aftersaleReport])"></div> -->

          <!-- <div class="bgcolor" v-if="hasPermissionGroup([...permissionGroup.productionManagement.personnelManagement,...permissionGroup.productionManagement.taskManagement])"></div> -->
           <el-submenu index="4" v-if="hasPermissionGroup([...permissionGroup.systemSettings.accountManager,...permissionGroup.systemSettings.roleManager,...permissionGroup.systemSettings.DataDictionary,...permissionGroup.systemSettings.accountLevel])">
            <template slot="title">
              <div class="title navThemm">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-xitong" style="font-size: 20px;"></svg-icon>
                </div>
                <span style="font-size: 16px;">系统设置</span>
              </div>
            </template>
            <el-menu-item index="/systemSet/accountAdmin" v-if="hasPermission(26)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-xitong-zhanghao" style="font-size:20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">账号管理</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/systemSet/roleAdmin/index" v-if="hasPermission(27)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-xitong-juese" style="font-size:20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">角色管理</span>
              </div>
            </el-menu-item>
            <el-menu-item index="/systemSet/accountLevel/index" v-if="hasPermission(353)" class="secondary-menu secondary-menu-else">
               <div class="title">
                <div class="icon-wrap">
                  <svg-icon icon-class="aside-xitong-dengji" style="font-size:20px;"></svg-icon>
                </div>
                <span style="font-size: 12px;">账号等级</span>
              </div>
            </el-menu-item>
            <!-- <el-menu-item-group>
              <el-menu-item
                class="secondary-menu"
                index="/systemSet/accountAdmin"
                style="padding-left:80px"
                v-if="hasPermission(26)"
              >账号管理</el-menu-item>
              <el-menu-item
                class="secondary-menu"
                index="/systemSet/roleAdmin/index"
                style="padding-left:80px"
                v-if="hasPermission(27)"
              >角色管理</el-menu-item>        
              <el-menu-item
                @click="handleClick"
                class="secondary-menu "
                index="/systemSet/accountLevel/index"
                style="padding-left:80px"
                v-if="hasPermission(353)"
              >账号等级</el-menu-item>
            </el-menu-item-group> -->
          </el-submenu>
          <!-- <div class="bgcolor" v-if="hasPermissionGroup([...permissionGroup.systemSettings.accountManager,...permissionGroup.systemSettings.roleManager,...permissionGroup.systemSettings.DataDictionary,...permissionGroup.systemSettings.accountLevel])"></div> -->
          <li role="menuitem" aria-haspopup="true" class="el-submenu" v-if="hasPermission(666)">
            <div class="el-submenu__title" style="padding-left: 20px; color: rgb(255, 255, 255);">
            <div class="title navThemm">
              <div class="icon-wrap">
                <svg-icon icon-class="aside-shengtai" style="font-size: 27px;"></svg-icon>
              </div>
              <span style="font-size: 16px;">生态服务</span>
            </div>
            </div>
          </li>
        </el-menu>
      </el-aside>
      <div class="hidden-aside" v-else ></div>
      <div class='open_icon' @click="handleCollapse">
        <img src="@/assets/v2/close-icon.png" alt="" v-if="isCollapse">
        <img src="@/assets/v2/open-icon.png" alt="" v-else>
      </div>
    </el-container>

    <!-- </el-menu> -->
    <change-pasaword ref="changeP"></change-pasaword>
  </div>
</template>
<style lang="scss">
.el-submenu__title{
   position: relative;
   margin-bottom:0px;
   padding: 0 8px!important;
}
.el-submenu__title:hover{
  background: transparent;
}
</style>

<style lang="scss" scoped>
.hidden-aside{
  width: 14px;
  height: calc(100vh - 60px);
  position: relative;
  background: #FFFFFF;
  [data-theme="theme1"] & {
    background: #00182C;
  }
  [data-theme="theme2_skyblue"] & {
    background: #fff;
  }
}
.show-aside{
  transition: 0.5s;
  width: 232px!important;
  // display: none;
  background: #FFFFFF;
  box-shadow: 0px 2px 16px 0px rgba(182,186,193,0.16);
// z-index: 11;
  [data-theme="theme1"] & {
    background: #00182C;
    box-shadow: 5px 0px 5px rgba(0, 217, 213, 0.35);
  }

  [data-theme="theme2_skyblue"] & {
    background: #fff;
    box-shadow: 6px 0px 12px rgba(18, 106, 233, 0.5);
  }
}
  .open_icon{
    // width: 25px;
    width: 45px;
    height: 95px;
    // background: #001F38;
    cursor: pointer;
    z-index: 10;
    position:absolute;
    right:-28px;
    top: 50%;
    margin-top: -35px;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      width: 100%;
      height: 100%;
    }

  }
.title {
  display: flex;
  align-items: center;
  .icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    padding-right: 8px;
  }
}
</style>

<script>
import { mapGetters } from "vuex";
import {loginErp} from "@/services/alarmRemind";
import changePasaword from "./changePassword";
export default {
  components: {changePasaword},
  inject: ["reload"], // 注入重载的功能（注入依赖）
  computed: {
    ...mapGetters(["theme"]),
  },

  data() {
    return {
      openeds:['1','2','3','4','5',],
      isCollapse: true,
      editableTabs2: [
        {
          title: "电池管理",
          name: "1",
          closable: false,
        },
      ],
    };
  },
  mounted() {
    //首次登录修改初始密码
          let loginFirst=JSON.parse(sessionStorage.getItem('loginFirst'))
          if(loginFirst==0){
              //判断当前账号是否已经修改过初始密码  避免刷新在弹出
              let ChangingInitialPw= sessionStorage.getItem('ChangingInitialPw')
              if(ChangingInitialPw&&ChangingInitialPw==sessionStorage.getItem('userid')+'true'){
                  return
              }else{
                this.$refs.changeP.openModel()
              }
          }
  },

  methods: {
      async handleToSupplyChain(){
           const res=await  loginErp(8);
           if(res){
               let url="http://erp.fnjkj.cn/#/login/tokenLogin?data="
               window.open(url+res.data)
           }
      },
      // 侧边栏展开收起
    handleCollapse(){
      this.isCollapse = !this.isCollapse;
      $(".show-aside").css({
        "width": "64px",
      });
    },
    //权限控制
    hasPermission(id) {
      // console.log(id,"id")
      return this.$store.getters.hasPermission(id);
    },
    // showBG(){
    //     return this.theme=="" || this.theme=="theme1"
    // },

    refs(name) {
      var that = this;
      that.$emit("listnone", name);
    },
    handleselect: function (a, b, index) {
      this.reload(); // 点击侧边栏重新载入页面
      // console.log(a)
      // console.log(index.itemStyle)
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClick() {},
  },
  //重写点击菜单的跳转方法
  // async mounted() {
  //     this.$refs.menus.routeToItem=(item)=>{
  //         let route = item.route || item.index;
  //         try {
  //             this.toCachePage({path:route});
  //         } catch (e) {
  //             console.error(e);
  //         }
  //      //   this.toCachePage({path:item})
  //     }
  // },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue